import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown, faClockRotateLeft, faConciergeBell, faListCheck } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import useServiceCategories from 'hooks/useServiceCategories';
import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';

interface AddButtonProps {
    className?: string;
    onAdd?: (type: 'booking' | 'evaluation') => void;
    onAddWaitlist?: () => void;
}

export const AddButton: FunctionComponent<AddButtonProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });
    const { hasEvaluation } = useServiceCategories();

    const dropdown = (
        <Dropdown>
            <DropdownTrigger className={props.className}>
                <Button
                    label="Add"
                    size={isMobile ? 'medium' : 'large'}
                    rightIcon={faAngleDown}
                />
            </DropdownTrigger>

            <DropdownContent
                minWidth={130}
                align="end"
            >
                <DropdownItem
                    leftIcon={faConciergeBell}
                    onSelect={() => props.onAdd?.('booking')}
                >
                    Appointment
                </DropdownItem>
                {hasEvaluation && (
                    <DropdownItem
                        leftIcon={faListCheck}
                        onSelect={() => props.onAdd?.('evaluation')}
                    >
                        Evaluation
                    </DropdownItem>
                )}
                {props.onAddWaitlist && (
                    <DropdownItem
                        leftIcon={faClockRotateLeft}
                        onSelect={props.onAddWaitlist}
                    >
                        Waitlist
                    </DropdownItem>
                )}
            </DropdownContent>
        </Dropdown>
    );

    const button = (
        <Button
            label="Add"
            size={isMobile ? 'medium' : 'large'}
            leftIcon={faPlus}
            onClick={() => props.onAdd?.('booking')}
        />
    );
    return hasEvaluation || props.onAddWaitlist ? dropdown : button;
};

export default AddButton;
